import React, { FC, ReactElement, useRef, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { StyleSheetManager } from 'styled-components'
import MainComponent from 'components/MainComponent'
import DevTools from 'DevTools'
import tenants from 'Constants/tenants'

const App: FC<MicroFrontendProps> = (microFrontendProps): ReactElement => {
  const [ref, setRef] = useState<HTMLDivElement | null>()
  const styleRef = useRef<any>()
  const [cssIsInjected, setCssIsInjected] = useState(false)

  if (styleRef.current) {
    styleRef.current.onload = () => {
      setCssIsInjected(true)
    }
    styleRef.current.onerror = () => {
      // if we don't have any css file (if you use styled components)
      setCssIsInjected(true)
    }
  }

  return (
    <div id='root' ref={(newRef) => setRef(newRef)}>
      <link
        ref={styleRef}
        rel='stylesheet'
        href={
          process.env.REACT_APP_DEPLOY_PATH
            ? process.env.REACT_APP_DEPLOY_PATH + '/static/css/main.css'
            : 'static/css/main.css'
        }
      />
      {ref && cssIsInjected && (
        <div id='app'>
          <StyleSheetManager target={ref}>
            <MainComponent {...microFrontendProps} />
          </StyleSheetManager>
        </div>
      )}
    </div>
  )
}
export default App
if (window.document.title === 'TA-Interaktiv Microfrontend') {
  const DevToolAppWrapper: FC = (): ReactElement => {
    const [isDarkmode, setIsDarkmode] = useState(false)
    const [currentTenantKey, setCurrentTenantKey] =
      useState<TenantKey>('tagesanzeiger')
    return (
      <DevTools
        setTenant={setCurrentTenantKey}
        setIsDarkmode={setIsDarkmode}
        isDarkmode={isDarkmode}
        currentTenantKey={currentTenantKey}
      >
        <App
          tenant={
            tenants.find((tenant) => tenant.key === currentTenantKey) as Tenant
          }
          colorMode={isDarkmode ? 'dark' : 'light'}
          properties={{
            component: 'SmallMultiple',
            // headlineGrid: 'Spitaleintritte',
            // leadGrid: 'Wöchentliche',
            dwSourceUrl: ['https://datawrapper.dwcdn.net/9UK7P/','https://datawrapper.dwcdn.net/9UK7P/','https://datawrapper.dwcdn.net/9UK7P/','https://datawrapper.dwcdn.net/9UK7P/', 'https://datawrapper.dwcdn.net/9UK7P/'],
            dwTitles: ['Lugano','Locarno-Monti'],
            altitude: ['200 m','300 m'],
            number: ['-10%','-15%'],
            dwDescriptions: ['Schneetage','Schneetage'],
            // widthGrid: '',
            // widthHeadlineGrid: 'TextWidthExtended',
            iFrameStyleHeight: '300px',
            gridColumnsDesktop: 3,
            gridColumnsMobile: 2,
            columnGapDesktop: '20px',
            columnGapMobile: '12px',
            source:'Quelle: Schnee- und Lawinenforschung (SLF), Bundesamt für Meteorologie und Klimatologie'
          }}
        />
      </DevTools>
    )
  }
  const root = createRoot(document.getElementById('root')!)
  root.render(
    <React.StrictMode>
      <DevToolAppWrapper />
    </React.StrictMode>
  )
}
